let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6uRgl")).then(() => parcelRequire('2brgI'));